export const fmtSize = (b) => (b > 1048576 ? `${(b / 1048576).toFixed(1)} MB` : `${Math.round(b / 1024)} KB`);
export const sum = (stats, k) => Object.values(stats || {}).reduce((s, v) => s + (v[k] || 0), 0);
export const fmtStamp = (iso) => (iso || "").slice(0, 16).replace("T", " ");
